<script setup>
import {defineEmits, defineProps} from 'vue'

defineProps({
    show: Boolean,
    loading: Boolean,
    disabled: Boolean,
    error: Boolean,
})

const emit = defineEmits(['press']);

function press() {
    emit('press');
}
</script>

<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'blue darken-2'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.activate')"
        :icon="error ? 'mdi-alert' : 'mdi-power-plug'"
        @press="press"
    />
</template>

<style scoped>

</style>